import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * ボタンカラム
 *【内容:content:string】
 *【選択候補:candidates:{label:string,value:string}[]】
 *【非活性:disabled:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-button-column',
  templateUrl: './button-column.html',
  styles: [`
    
  `]
})
export class ButtonColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * 選択候補
   */
  @Input() candidates:{label:string,value:string}[]

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  get selectedItem():{label:string,value:string} {
    return (this.candidates || []).find(
      each => each.value === this.content
    ) || {label:'', value:''}
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/button-column/button-column.component.ts